// extracted by mini-css-extract-plugin
export default {"image-message":"_advertisment-image-message-59246b","image-title":"_advertisment-image-title-73d5d9","image-footer":"_advertisment-image-footer-9f68c5"};